import React from "react"
import BasicInput from "../../BasicInput/BasicInput"
import { FaMinus, FaPlus } from "react-icons/fa6"

const QuantityInput = ({
    label,
    feature,
    value,
    onChange,
    values,
    ...props
}) => {
    return (
        <div className="row align-items-center mb-3">
            <div className="col-md-3">
                <label className="form-label fw-medium">{label}</label>
            </div>
            <div className="row col-md-8 m-0 p-0 justify-content-between align-items-center">
                <div
                    className="col-1 d-flex align-items-center justify-content-center m-0 p-3"
                    style={{
                        backgroundColor: "#fff",
                        borderRadius: "8px",
                        cursor: "pointer",
                        userSelect: "none"
                    }}
                    onClick={(e) => {
                        if (values.quantity > 1) {
                            onChange(feature.slug, values.quantity - 1)
                        }
                    }}
                >
                    <FaMinus />
                </div>
                <div className="col-9 m-0 p-0">
                    <BasicInput
                        key={feature.slug}
                        feature={feature}
                        label={feature?.name}
                        type={feature.type}
                        value={values[feature.slug]}
                        onChange={onChange}
                        hideLabel={true}
                        styling={{
                            marginBottom: "0px !important"
                        }}
                        inputCenter={true}
                        disabled={true}
                    />
                </div>
                <div
                    className="col-1 d-flex align-items-center justify-content-center m-0 p-3"
                    style={{
                        backgroundColor: "#fff",
                        borderRadius: "8px",
                        cursor: "pointer",
                        userSelect: "none"
                    }}
                    onClick={(e) => {
                        onChange(feature.slug, values.quantity + 1)
                    }}
                >
                    <FaPlus />
                </div>
            </div>
        </div>
    )
}

export default QuantityInput